import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.css'],
    standalone: false
})
export class InvoiceComponent implements OnInit {

  role
  customers: []
  serverErrorMessages: string
  loading: boolean = true;
  closeResult;
  customer:{}
  pdfLoading: boolean = false
  filterForm = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
  })
  constructor(private loginService: LoginService,private router : Router, private moderatorService: ModeratorService, private modalService: NgbModal,private datePipe: DatePipe) {}

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllCustomers();
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  getAllCustomers(){
    this.moderatorService.getAllCustomer().subscribe(
      res=>{
       //console.log('got all customers', res)
        this.customers = res['customers']
      },
      err=>{
       //console.log('error while getting all customers', err)
      }
    )
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  clearDate(event) {
    event.stopPropagation();
    this.filterForm.get('startDate').setValue(null);
    this.filterForm.get('endDate').setValue(null);
  }

  sendInvoice(customerID, fullName){
    this.pdfLoading = true;
    this.moderatorService.sendInvoice(customerID)
    .then(resp => resp.arrayBuffer()).then(resp => {
      const file = new Blob([resp], {type: 'application/pdf'});
      // process to auto download it
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = customerID + '_' + fullName + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd') + ".pdf";
      link.click();
      this.pdfLoading = false;
    });
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

  sendInvoiceDateFilter(){
    const customerID  = this.customer['_id']
    const startDate=this.filterForm.get('startDate').value
    const endDate=this.filterForm.get('endDate').value
    this.pdfLoading = true;
    this.moderatorService.sendInvoiceDateFilter(customerID, startDate, endDate)
    .then(resp =>
      {
        if(resp.status === 500) throw new Error('gg')
        else return resp.arrayBuffer()
      }).then(resp => {
      const file = new Blob([resp], {type: 'application/pdf'});
      // process to auto download it
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = customerID + '_' + this.customer['fullName'] + '_' + this.datePipe.transform(startDate, 'yyyy-MM-dd') + 'to' + this.datePipe.transform(endDate, 'yyyy-MM-dd') + ".pdf";
      link.click();
      this.pdfLoading = false;
    }).catch(err => {
     //console.log('errorrrr', err)
      alert('No transactions found! Please try other dates')
      this.pdfLoading = false;
    });

  }

  open(content, customer) {
    this.customer = customer
   //console.log('got customer', this.customer)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}
